import React, { FC } from 'react'
import url from 'url'
import { buttonVariants } from 'design-system'

import { Link } from 'src/lib/router'
import { useRouter } from 'next/router'
import { ShareLinkWrapper } from './wrapper'

interface UserLoginProps {
  title: string
  token: string
}

export const UserLogin: FC<UserLoginProps> = ({ title, token }) => {
  const { asPath } = useRouter()

  const loginUrl = url.format({
    pathname: '/user/login',
    query: { redirect: asPath }
  })
  const createUrl = url.format({
    pathname: '/user/create',
    query: { redirect: asPath, shareToken: token }
  })

  return (
    <ShareLinkWrapper>
      <h2 className="text-base font-light text-neutral-600">
        You have reached the <span className="font-medium">{title}</span>{' '}
        community.
      </h2>
      <p className="mb-4 text-neutral-600">Would you like to join?</p>
      <Link
        href={loginUrl}
        className={buttonVariants({ buttonType: 'primary' })}
        exact>
        Login
      </Link>
      <Link
        href={createUrl}
        className={buttonVariants({ buttonType: 'primary' })}
        exact>
        Create Account
      </Link>
    </ShareLinkWrapper>
  )
}
